import { defineStore } from "pinia"
import Keycloak from "keycloak-js"

import type { LoginStore } from "./types/store"

const KEYCLOAK_JSON = {
    realm: "org-plus",
    url: "https://login.iprpraha.cz/auth/",
    "ssl-required": "external",
    clientId: "langweiluv-model",
    "use-resource-role-mappings": true,
    "public-client": true,
    "verify-token-audience": true,
    "confidential-port": 0,
}

type LoginStore = {
    logged: boolean
    failedLogin: boolean
    keycloak?: Keycloak
    roles: string[]
}

export const useLogin = defineStore("keycloak", {
    state: (): LoginStore => {
        return {
            logged: true,
            failedLogin: false,
            keycloak: undefined,
            roles: ["user"],
        }
    },
    getters: {
        hasAccess: state => {
            return state.logged && state.roles.includes("user")
        },
    },
    actions: {
        async login() {
            try {
                this.keycloak = new Keycloak(KEYCLOAK_JSON)
                try {
                    const authenticated = await this.keycloak.init({
                        onLoad: "login-required",
                        promiseType: "native",
                        locale: "cs",
                        kcLocale: "cs",
                        "enable-cors": true,
                    })
                    this.resolveSuccessLogin(authenticated)
                } catch (err) {
                    this.resolveFailedLogin(err)
                }
            } catch (error) {
                this.resolveFailedLogin(error)
            }
        },
        async logout() {
            const url = window.location.href.split("editace")[0]
            await this.keycloak.logout({ redirectUri: url })
        },
        resolveSuccessLogin(authenticated: boolean) {
            if (authenticated) {
                this.logged = true
                this.roles = this.keycloak.resourceAccess["langweiluv-model"]
                    ? this.keycloak.resourceAccess["langweiluv-model"].roles
                    : []
                console.log("keycloak", this.keycloak)
            } else {
                this.resolveFailedLogin()
            }
        },
        resolveFailedLogin(err?: unknown) {
            console.log(err)
            this.failedLogin = true
        },
    },
})
